<template>
  <div>
    <Drawer
      title="新增流程"
      :closable="false"
      :width="width"
      v-model="openForm"
    >
      <div id="acewdsc">
        <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
          <Row :gutter="16">
            <Col span="24">
              <FormItem label="流程名称" prop="name">
                <Input
                  ref="sdsd"
                  v-model="item.name"
                  placeholder="请输入"
                ></Input>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="单位名称" prop="groupName">
                <selectGroup
                  :name="item.groupName"
                  @update:name="item.groupName = $event"
                  :id="item.groupId"
                  @update:id="item.groupId = $event"
                  :disabled="!isAdd"
                >
                </selectGroup>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="流程细节" prop="name">
                <ul id="nodeList">
                  <li v-for="(x, index) in item.nodeList" :key="index">
                    <Dropdown placement="bottom-start">
                      <Input
                        :readonly="x.type == 0 || x.type == 2"
                        v-model="x.name"
                        class="nodeListTitle"
                      ></Input>
                      <DropdownMenu slot="list" v-if="x.type != 2">
                        <DropdownItem
                          ><span @click="addPross(index)">插入节点</span>
                        </DropdownItem>
                        <DropdownItem v-show="x.type != 0">
                          <span @click="delPross(index)">删除节点</span>
                        </DropdownItem>
                        <DropdownItem v-show="x.type != 0">
                          <span @click="addperLine(x, index)">后退线</span>
                        </DropdownItem>
                        <DropdownItem v-show="x.type != 0"
                          ><span @click="addContent(x, index)"
                            >节点内容</span
                          ></DropdownItem
                        >
                        <DropdownItem v-show="x.type != 0">
                          <span @click="addRole(x)">添加角色</span>
                        </DropdownItem>
                        <DropdownItem v-show="x.type != 0">
                          <span @click="addUser(x)">添加用户</span>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>

                    <ly-form-item v-show="x.contentShow" label="内容" lw="2"
                      ><Input
                        v-model="x.content"
                        class="nodeListContent"
                        ref="aaa"
                        @on-blur="contentOnBlur(x)"
                        @on-clear="addContent(x, index)"
                        clearable
                      ></Input>
                    </ly-form-item>
                    <ly-form-item
                      v-show="x.role.length > 0"
                      label="角色"
                      lw="2.5"
                    >
                      <div>
                        <span
                          @click="addRole(x)"
                          v-for="(y, index1) in x.role"
                          :key="index1"
                          >{{ y.name }}</span
                        >
                      </div>
                      <Icon type="md-close-circle" @click="x.role = ''"
                    /></ly-form-item>
                    <ly-form-item
                      v-show="x.user.length > 0"
                      label="用户"
                      lw="2.5"
                      ><div>
                        <span
                          @click="addUser(x)"
                          v-for="(y, index1) in x.user"
                          :key="index1"
                          >{{ y.name }}</span
                        >
                      </div>
                      <Icon type="md-close-circle" @click="x.user = ''"
                    /></ly-form-item>
                    <div class="pro_next">
                      <p v-if="x.type != 2">
                        <Icon type="md-arrow-down" />
                        <Input v-model="x.nextLine"></Input>
                      </p>
                      <p v-show="x.perLineShow">
                        <Icon type="md-arrow-up" />
                        <Input
                          ref="perLine"
                          v-model="x.perLine"
                          @on-blur="perLineOnBlur(x)"
                        ></Input>
                      </p>
                    </div>
                  </li>
                </ul>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>

      <Row :gutter="16">
        <Col span="24">
          <Button type="primary" long>提交保存</Button>
        </Col>
      </Row>
    </Drawer>
    <Drawer
      class="my-drawer"
      title="添加角色"
      :closable="false"
      :width="300"
      v-model="openRole"
    >
      <userTree v-if="false" @user="reUser"></userTree>
    </Drawer>
    <Drawer
      class="my-drawer"
      title="添加用户"
      :closable="false"
      :width="300"
      v-model="openUser"
    >
      <userTree @user="reUser"></userTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openForm: true,
      openRole: false,
      openUser: false,
      isAdd: true,
      width: 350,
      item: {
        groupId: "",
        groupName: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },
      roles: [
        {
          name: "管理员",
          id: 123,
          select: false,
        },
        {
          name: "驾驶员",
          id: 123,
          select: false,
        },
        {
          name: "企业职工",
          id: 123,
          select: false,
        },
      ],
      users: [
        {
          name: "张三",
          id: 123,
          select: false,
        },
        {
          name: "李四",
          id: 123,
          select: false,
        },
        {
          name: "王五",
          id: 123,
          select: false,
        },
      ],
    };
  },
  methods: {
    addPross(index) {
      var obj = {
        name: "节点名称",
        id: "T0003",
        nextLine: "分派",
        perLine: "驳回",
        perLineShow: true,
        content: "任务描述",
        contentShow: true,
        role: "",
        user: "",
        type: 1,
      };

      this.item.nodeList.splice(index + 1, 0, obj);
    },
    delPross(index) {
      this.item.nodeList.splice(index, 1);
    },
    contentOnBlur(x) {
      if (x.content.length == 0) {
        x.contentShow = false;
      }
    },
    addContent(x, index) {
      x.contentShow = true;
      setTimeout(() => {
        this.$refs.aaa[index].focus();
      }, 200);
      return;
      //this.$refs.contentT0003.focus();
      console.log(this.$refs[`content${v.id}`]);
      this.$refs[`content${v.id}`][0].focus();
    },
    perLineOnBlur(x) {
      if (x.perLine.length == 0) {
        x.perLineShow = false;
      }
    },
    addperLine(x, index) {
      x.perLineShow = true;
      setTimeout(() => {
        this.$refs.perLine[index].focus();
      }, 200);
    },
    addRole(x) {
      this.openRole = true;
    },
    selectRole(x) {
      x.select = !x.select;
    },
    addUser(x) {
      this.openUser = true;
      x.select = !x.select;
    },
    reUser(x) {
      this.item.nodeList[1].user.push(x);
    },
    getnode() {
      var data = {
        groupId: "1574225429573996546",
        name: "东西部大桥-巡查流程2234",
        nodeList: [
          {
            name: "开始",
            id: "E001",
            content: "",
            nextLine: "",
            perLine: "",
            role: [],
            user: [],
            type: 0,
          },
          {
            name: "项目管理员",
            id: "T002",
            content: "",
            nextLine: "分派",
            perLine: "驳回",
            role: [
              {
                id: "1534087707940421633",
                name: "环卫工人",
              },
            ],
            user: [
              {
                accountId: "1534781286828539906",
                name: "江涛",
              },
            ],
            type: 1,
          },
          {
            name: "班组长",
            id: "T0003",
            content: "下发任务给组员",
            nextLine: "分派",
            perLine: "驳回",
            role: [],
            user: [],
            type: 1,
          },
          {
            name: "醒目管理员",
            id: "T004",
            content: "预验收",
            nextLine: "验收",
            perLine: "驳回",
            role: [],
            user: [],
            type: 1,
          },
          {
            name: "项目负责人",
            id: "T005",
            content: "",
            nextLine: "确认验收",
            perLine: "",
            role: [],
            user: [],
            type: 1,
          },
          {
            name: "结束",
            id: "E002",
            content: "",
            nextLine: "",
            perLine: "",
            role: [],
            user: [],
            type: 2,
          },
        ],
        content: null,
        serverUrl: "cloud-ep-server-event/event",
        moduleTable: "",
        status: 0,
        ver: 1,
      };
      var x = data.nodeList;
      for (const i in x) {
        x[i].perLineShow = x[i].perLine.length == 0 ? false : true;
        x[i].contentShow = x[i].content.length == 0 ? false : true;
      }
      this.item = data;
    },
  },
  watch: {
    openRole(v) {
      this.width = v ? 650 : 350;
    },
    openUser(v) {
      this.width = v ? 650 : 350;
    },
  },
  mounted() {
    this.getnode();
  },
};
</script>
<style lang="">
#nodeList {
  width: 100%;
  margin-bottom: 18px;
}
#acewdsc {
  height: calc(100% - 40px);
  overflow: auto;
  overflow-x: hidden;
}
#nodeList li {
  margin-bottom: 15px;
}
#nodeList li .lyformitem {
  margin-bottom: 0px;
  cursor: pointer;
  margin-left: 6px;
}
#nodeList li .lyformitem > p > div {
  width: calc(100% - 26px);
  display: inline-block;
  margin-right: 4px;
}
#nodeList li .lyformitem > p > div >span{
  margin-right: 4px;
}
#nodeList li .lyformitem > p > i {
  font-size: 16px;
  display: none;
}
#nodeList li .lyformitem:hover > p > i {
  display: inline;
}
#nodeList input {
  border: none;
}
#nodeList input:active {
  outline: none;
}
#nodeList .nodeListTitle {
  width: 160px;
}
#nodeList .nodeListTitle input {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}
#nodeList .nodeListContent input {
  margin-top: -4px;
}
#nodeList .pro_next {
  display: flex;
}
#nodeList .pro_next > p {
  display: flex;
  margin-right: 10px;
}
#nodeList .pro_next > p i {
  font-size: 24px;
  margin-top: 6px;
  color: #888;
}
#nodeList .pro_next > p input {
  width: 70px;
}
.acsdecwe li {
  cursor: pointer;
  padding: 10px 4px;
}
.acsdecwe li.active,
.acsdecwe li:hover {
  background: #e4ebfd;
}
</style>


// WEBPACK FOOTER //
// src/components/liucheng/liucheng.vue